import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Button, Col, Container, CustomInput, Form, Label, Row } from 'reactstrap';
import Icon from '../../components/Icon';
import ApiV2ModelContext from '../../contexts/ApiV2ModelContext';
class ProfileForm extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            newsletterEnabled: null,
            otherEmailsEnabled: null,
            weeklyReportEnabled: null,
            storing: false,
        };
        this.handleToggleCheckbox = (property, value) => {
            // @ts-expect-error TS2345: Argument of type { [x: string]: boolean; } is not assignable to parameter of type
            return this.setState({ [property]: value });
        };
        this.handleSubmit = async (event) => {
            event.preventDefault();
            const { dispatch } = this.props;
            try {
                this.setState({ storing: true });
                const notifications = {
                    otherEmailsEnabled: this.state.otherEmailsEnabled,
                    newsletterEnabled: this.state.newsletterEnabled,
                    weeklyReportEnabled: this.state.weeklyReportEnabled,
                };
                await this.context.updateUserNotifications(notifications, dispatch);
            }
            catch (error) {
                console.error(error);
            }
            finally {
                this.setState({ storing: false });
            }
        };
    }
    componentDidMount() {
        const { user } = this.props;
        const { weeklyReportEnabled } = this.state;
        if (weeklyReportEnabled === null && user.user) {
            const { newsletterEnabled, otherEmailsEnabled, weeklyReportEnabled: weeklyReportEnabledForUser } = user.user;
            return this.setState({
                newsletterEnabled,
                otherEmailsEnabled,
                weeklyReportEnabled: weeklyReportEnabledForUser,
            });
        }
    }
    render() {
        const { user, t } = this.props;
        if (!user.user) {
            return null;
        }
        return (_jsxs(Form, { onSubmit: this.handleSubmit, children: [_jsxs(Container, { children: [_jsxs(Row, { className: "mt-2 mb-2", children: [_jsx(Col, { xs: 10, children: _jsxs(Label, { for: "weeklyReportEnabled", className: "custom-control-left-label", children: [t('settings.weeklyReport'), _jsx("br", {}), _jsx("small", { className: "custom-control-left-label-description", children: t('settings.weeklyReportDesc') })] }) }), _jsx(Col, { xs: 2, className: "text-right align-self-center", children: _jsx(CustomInput, { type: "switch", id: "weeklyReportEnabled", name: "weeklyReportEnabled", 
                                        // label={t('settings.weeklyReport')}
                                        checked: Boolean(this.state.weeklyReportEnabled), onChange: (event) => this.handleToggleCheckbox('weeklyReportEnabled', event.target.checked) }) })] }), _jsxs(Row, { className: "mt-2 mb-2", children: [_jsx(Col, { xs: 10, children: _jsxs(Label, { for: "newsletterEnabled", className: "custom-control-left-label", children: [t('settings.newsletter'), _jsx("br", {}), _jsx("small", { className: "custom-control-left-label-description", children: t('settings.newsletterDesc', {
                                                    siteName: t('siteName'),
                                                }) })] }) }), _jsx(Col, { xs: 2, className: "text-right align-self-center", children: _jsx(CustomInput, { type: "switch", id: "newsletterEnabled", name: "newsletterEnabled", 
                                        // label={t('settings.newsletter')}
                                        checked: Boolean(this.state.newsletterEnabled), onChange: (event) => this.handleToggleCheckbox('newsletterEnabled', event.target.checked) }) })] }), _jsxs(Row, { className: "mt-2 mb-2", children: [_jsx(Col, { xs: 10, children: _jsxs(Label, { for: "otherEmailsEnabled", className: "custom-control-left-label", children: [t('settings.otherEmails'), _jsx("br", {}), _jsx("small", { className: "custom-control-left-label-description", children: t('settings.otherEmailsDesc') })] }) }), _jsx(Col, { xs: 2, className: "text-right align-self-center", children: _jsx(CustomInput, { type: "switch", id: "otherEmailsEnabled", name: "otherEmailsEnabled", 
                                        // label={t('settings.otherEmails')}
                                        checked: Boolean(this.state.otherEmailsEnabled), onChange: (event) => this.handleToggleCheckbox('otherEmailsEnabled', event.target.checked) }) })] })] }), _jsx("div", { className: "text-center mt-5", children: _jsxs(Button, { type: "submit", disabled: this.state.storing, children: [!this.state.storing ? null : _jsx(Icon, { name: "spinner", pulse: true, className: "mr-2", fixedWidth: true }), t('save')] }) })] }));
    }
}
ProfileForm.contextType = ApiV2ModelContext;
const mapStateToProps = (state) => ({
    user: state.user,
});
const mapDispatchToProps = (dispatch) => ({
    dispatch: dispatch,
});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ProfileForm));
